import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import swal from "sweetalert";
import MUIDataTable from "mui-datatables";
import { IconButton } from "@mui/material";
import EditIcon from "@material-ui/icons/Edit";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/core/styles";
import { createTheme } from "@material-ui/core/styles";
import { FaPlus } from "react-icons/fa";
import Layout from "../../components/admin/Layout";
import EditUser from "../../components/forms/EditUser";
import { useRecoilValue } from "recoil";
import { authState } from "../../recoil";

const Users = () => {
  const authToken = useRecoilValue(authState);
  const [users, setUsers] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editRow, setEditRow] = useState(-1);
  const [pageCount, setPageCount] = useState(0);
  const [totalPage, setTotalPage] = useState("");


  useEffect(() => {
    axios
      .post("/api/getusers", {
        page: pageCount,
      })
      .then((res) => {
        const newUsers = res?.data.data.map((el) => {
          return {
            ...el,
            user_firstname: el.user_firstname + " " + el.user_lastname,
          };
        });
        setUsers(newUsers);
        setTotalPage(res.data.pages);
      })
      .catch((err) => {
        toast.error("Failed to get users");
        document.location.reload(true);
      });
  }, [authToken]);

  const handelIncrement = () => {
    axios
      .post("/api/getusers", {
        page: pageCount + 1,
      })
      .then((res) => {
        const newUsers = res?.data.data.map((el) => {
          return {
            ...el,
            user_firstname: el.user_firstname + " " + el.user_lastname,
          };
        });
        if (res.data.pages !== pageCount) {
          setUsers(newUsers);
          setTotalPage(res.data.pages);
          setPageCount(pageCount + 1);
        }
      })
      .catch((err) => {
        toast.error("Failed to get users");
      });
  };

  const handelDecrement = () => {
    axios
      .post("/api/getusers", {
        page: pageCount - 1,
      })
      .then((res) => {
        const newUsers = res?.data.data.map((el) => {
          return {
            ...el,
            user_firstname: el.user_firstname + " " + el.user_lastname,
          };
        });
        setUsers(newUsers);
        setTotalPage(res.data.pages);
        setPageCount(pageCount - 1);
      })
      .catch((err) => {
        toast.error("Failed to get users");
      });
  };

  const columns = [
    { name: "id", label: "ID", options: { filterType: "textField" } },
    { name: "user_firstname", label: "Name", options: { filterType: "textField" } },
    { name: "user_email", label: "E-mail", options: { filterType: "textField" } },
    { name: "user_mobile", label: "phone", options: { filterType: "textField" } },
    { name: "user_role", label: "Role", options: { filterType: "dropdown", filterOptions: ["Admin", "User", "Vendor"], } },

    // {
    //   name: "Edit",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     empty: true,
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       return (
    //         <IconButton
    //           style={{ order: -1 }}
    //           onClick={() => {
    //             setEditRow(users[tableMeta.rowIndex]);
    //             setShowEditModal(true);
    //           }}
    //         >
    //           <EditIcon />
    //         </IconButton>
    //       );
    //     },
    //   },
    // },
  ];

  const options = {
    selectableRows: "multiple",
    draggableColumns: { enabled: true },
    jumpToPage: true,
    hasIndex: true,

    customFooter: (
      count,
      page,
      rowsPerPage,
      changeRowsPerPage,
      changePage,
      textLabels
    ) => {
      return (
        <div className="pagenation">
          {/* {pageCount > 0 && (
            <button className="left-arr" onClick={handelDecrement}>
              &lt;
            </button>
          )}

          {pageCount !== totalPage && (
            <button className="right-arr" onClick={handelIncrement}>
              &gt;
            </button>
          )} */}
        </div>
      );
    },

    onRowsDelete: (rowsDeleted) => {
      swal({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this field!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          for (var i = 0; i < rowsDeleted.data.length; i++) {
            axios
              .delete(`api`)
              .then((res) => {
                if (res.data.status) {
                  toast.success("Deleted Successfully");
                } else {
                  toast.error(`Failed with status ${res.data.status}`);
                }
              })
              .catch((err) => {
                toast.error("can't delete");
                console.log(err);
              });
          }
        } else {
          swal("The entry is safe!").then((val) => window.location.reload());
        }
      });
    },
  };

  const getMuiTheme = () =>
    createTheme({
      overrides: {
        MUIDataTableToolbar: {
          actions: {
            display: "flex",
            flexDirection: "row",
            flex: "initial",
          },
        },
        MuiToolbar: {
          root: {
            color: "#1fd0b4",
          },
        },
        MuiTableHead: {
          root: {
            color: "#1fd0b4",
          },
        },
      },
    });

  return (
    <Layout>
      {!showEditModal ? (
        <div className="users">
          <Link to="/users/add">
            <button className="add-btn">
              <FaPlus className="icon" />
              Add User
            </button>
          </Link>

          <MuiThemeProvider theme={getMuiTheme()}>
            <MUIDataTable
              title={"Users"}
              data={users}
              columns={columns}
              options={options}
            />
          </MuiThemeProvider>
        </div>
      ) : (
        <EditUser
          show={showEditModal}
          hide={() => setShowEditModal(false)}
          columns={columns}
          btn="Add New Row"
          row={editRow}
        />
      )}
    </Layout>
  );
};

export default Users;
